import React from 'react';
import Avatar from '../Images/new_pro.png'
import Footer from '../Component/NewFooter';
import Renaissance from '../Images/renaissance_nobg.png'
import Seepco from '../Images/seepco_nobg.png'
import Total from '../Images/totalbg.png'

import Antan from '../Images/antan_nobg.png'
import Chewron from '../Images/chevron_nobg.png'
import Heir from '../Images/heirs_nobg.png'

const ProjectTable = () => {
  
  const projects = [ 
    {
      id: 1,
      yearCompleted: 'Ongoing',
      project: 'Provision of Location Preparation Services at Egbema West 13, Rivers State.',
      // description: 'Provision of Technical Services for Sundyne Pumps for Seplat West Operations across Oben, Amukpe, and Sapele Fields (OMLs 4, 38 & 41)',
      client: Renaissance
    },
    {
      id: 2,
      yearCompleted: 'Ongoing',
      project: 'Assa-North – Ohaji South, Imo State Project: Installation and Construction of 33KV Transmission Line for Assa North CEIP.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Renaissance
    },
    {
      id: 4,
      yearCompleted: 'Ongoing',
      project: 'Rehabilitation of Egbema West Well 13 Road Project at Egbema, Rivers State. ',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Renaissance
    },
    {
      id: 5,
      yearCompleted: 'Completed',
      project: 'Construction of residential colony at Agu community, Ohaji/Egbema LGA, Imo State.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Seepco
    },
    {
      id: 6,
      yearCompleted: 'Completed',
      project: 'Construction of a Residential Colony at Kwale, Delta State.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Seepco
    },
    {
      id: 7,
      yearCompleted: 'Ongoing',
      project: ' Provision of Support Services for Government Security Agencies (GSA)',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Renaissance
    },
    {
      id: 8,
      yearCompleted: 'Ongoing',
      project: 'Provision of Administrative Support Services',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Total
    },
    {
      id: 9,
      yearCompleted: 'Completed',
      project: 'Provision for administrative support services',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Antan
    },
    {
      id: 10,
      yearCompleted: 'Completed',
      project: 'OML 58 Obagi upgrade, Obagi, Rivers State.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Total
    },
    {
      id: 11,
      yearCompleted: 'Completed',
      project: 'OFON 102 field development, Phase 2',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Total
    },
    {
      id: 12,
      yearCompleted: 'Completed',
      project: 'Turnaround maintenance projects for Chevron including the Escravos gas plant, the FSO (Floating Storage and offloading) facility, and the gas-to-liquids facility Agbami FPSO maintenance.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Chewron
    },
    {
      id: 14,
      yearCompleted: 'Completed',
      project: 'Installation of paving stones',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Heir
    },
    {
      id: 13,
      yearCompleted: 'Completed',
      project: 'OML 58 Solarization Project. Obagi/Obite, Omoku, Rivers State.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Total
    },
    {
      id: 15,
      yearCompleted: 'Ongoing',
      project: 'Commissioning & Well Intervention Project at Excravos, Delta State.',
      // description: 'Provision of Technical Assistance Services (Expatriate manpower supply – Lead Fabric Maintenance – Offshore) for Total JV Assets',
      client: Renaissance
    },
  ];

  // Pattern: Row 0 (Year) = gray, Row 1 (Project) = white, Row 2 (Desc) = gray, Row 3 (Client) = white
  const isGrayRow = (rowIndex) => rowIndex % 2 === 0; // 0, 2 are gray; 1, 3 are white

  return (
    <div className='color_project'>
      <div className="img_carrierpj">
        <img src={Avatar} alt="img" />
      </div>
    
    <div className="container">
      {/* <h1 className="year-title">2026</h1> */}
      
      <div className="table-container">
        <table className="data-table">
          <tbody>
            {projects.map((project, projectIndex) => (
              <React.Fragment key={project.id}>
                {/* Row 0: Year Completed - GRAY both columns */}
                <tr className={isGrayRow(0) ? 'row-gray' : 'row-white'}>
                  <td className="col-label">Project:</td>
                  <td className="col-value">{project.project}</td>
                </tr>
                
                
                {/* Row 2: Project description - GRAY both columns */}
                <tr className={isGrayRow(2) ? 'row-gray' : 'row-white'}>
                  {/* <td className="col-label">Project description:</td> */}
                  {/* <td className="col-value">{project.description}</td> */}
                </tr>
                
                {/* Row 3: Client - WHITE both columns */}
                <tr className={isGrayRow(3) ? 'row-gray' : 'row-white'}>
                  <td className="col-label">Client:</td><td className="col-value">
                    <img 
                      src={project.client} 
                      alt="Client" 
                      style={{ width: "200px", height: "80px", objectFit: "contain" }}
                    />
                  </td>
                </tr>

                {/* Row 1: Project - WHITE both columns */}
                <tr className={isGrayRow(1) ? 'row-gray' : 'row-white'}>
                  <td className="col-label">Status:</td>
                  <td className="col-value">{project.yearCompleted}</td>
                </tr>
                
                {/* Empty separator rows between projects */}
                {projectIndex < projects.length - 1 && (
                  <>
                    {/* Empty row 1: GRAY both columns */}
                    <tr className="empty-row row-gray">
                      <td className="col-label"></td>
                      <td className="col-value"></td>
                    </tr>
                    {/* Empty row 2: WHITE both columns */}
                    <tr className="empty-row row-white">
                      <td className="col-label"></td>
                      <td className="col-value"></td>
                    </tr>
                  </>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <p style={{fontWeight:'bolder', marginTop: '2rem', fontSize:'20px'}}>Delivering excellence today, building the future tomorrow and more successful Projects to come...</p>
      </div>

      <style jsx>{`
        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 40px;
          font-family: Arial, Helvetica, sans-serif;
        }
        .color_project{
          background: #e5fce5;
        }
        .year-title {
          font-size: 42px;
          font-weight: normal;
          color: #333;
          margin: 0 0 25px 0;
          padding: 0;
        }

        .table-container {
          width: 100%;
          background: #e5fce5 !important;
        }

        .data-table {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
        }

        .data-table td {
          padding: 14px 16px;
          font-size: 15px;
          font-weight: bold;
          line-height: 1.5;
          border-bottom: 1px solid #000;
          vertical-align: top;
        }

        /* Row background colors - both columns same */
        .row-gray td {
          background-color: #f7bb2f;
        }

        .row-white td {
          background-color: #e5fce5;
        }

        .col-label {
          width: 22%;
          color: #444;
          font-weight: normal;
          border-right: 1px solid #000;
        }

        .col-value {
          width: 78%;
          color: #333;
        }

        .empty-row td {
          height: 32px;
          padding: 0 16px;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .container {
            padding: 20px;
          }

          .year-title {
            font-size: 32px;
          }

          .data-table td {
            padding: 12px 14px;
            font-size: 12px;
          }

          .col-label {
            width: 30%;
          }

          .col-value {
            width: 70%;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding: 15px;
          }

          .year-title {
            font-size: 28px;
            margin-bottom: 15px;
          }

          .data-table {
            display: block;
          }

          .data-table tbody {
            display: block;
          }

          .data-table tr {
            display: flex;
            flex-direction: column;
            margin-bottom: 8px;
          }

          .col-label {
            width: 100%;
            border-right: none;
            font-weight: 600;
            padding: 10px 14px;
          }

          .col-value {
            width: 100%;
            padding: 12px 14px;
          }

          .empty-row {
            display: none;
          }
        }
      `}</style>
    </div>
    <Footer/>
    </div>
  );
};

export default ProjectTable;